import React, { useState } from 'react';
import { MainProvider, MainProviderProps } from './MainProvider';
import { EventProvider } from './EventProvider';
import { MicroFrontendProps } from '../core';

interface AppContextProps {
  props?: any;
  setProps?: React.Dispatch<React.SetStateAction<any | undefined>>;
}

export const AppContext = React.createContext<AppContextProps>({});

export interface AppProviderProps extends MainProviderProps {
  propsEvent: string;
};

export const AppProvider = ({
  client,
  tryGuestLogin,
  getClient,
  propsEvent,
  children,
  ...initialProps
}: AppProviderProps) => {
  const [props, setProps] = useState<Partial<MicroFrontendProps>>(initialProps);

  window.addEventListener(propsEvent, (newProps) => {
    setProps((newProps as CustomEvent).detail);
  });

  const graphClient = getClient?.({ lang: initialProps.lang, tryGuestLogin });
  const finalClient = graphClient?.client || client;

  return (
    <AppContext.Provider value={{ props, setProps }}>
      <MainProvider finalClient={finalClient} {...props}>
        <EventProvider>
          {children}
        </EventProvider>
      </MainProvider>
    </AppContext.Provider>
  );
};
